export default (incident: Incident | null) => {
  if (incident === null || incident === undefined) {
    return '-';
  }
  let name = incident.incident_number;
  if (incident.name || incident.address?.postal_community) {
    name += ` - ${incident.name || incident.address?.postal_community}`;
  }

  return name;
};
